'use client'

import MarketingShell from '@/components/marketing/MarketingShell'
import Link from 'next/link'

export default function PricingPage() {
  return (
    <MarketingShell>
      <section
        style={{
          marginTop: 18,
          borderRadius: 22,
          border: '1px solid var(--border)',
          background:
            'radial-gradient(1100px 500px at 12% 0%, rgba(99,102,241,0.18), transparent 55%), radial-gradient(900px 500px at 90% 10%, rgba(14,165,233,0.16), transparent 60%), var(--panel)',
          padding: 22
        }}
      >
        <h1 style={{ margin: 0, fontSize: 46, letterSpacing: '-0.04em', lineHeight: 1.05 }}>Pricing</h1>
        <p style={{ marginTop: 12, color: 'var(--muted)', lineHeight: 1.7, maxWidth: 760 }}>
          Start free. Upgrade when you need deeper ATS insights and higher usage limits.
        </p>

        <div style={{ marginTop: 16, display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 14 }}>
          {[
            {
              name: 'Free',
              price: '$0',
              bullets: ['1 resume', 'Basic ATS keyword check', 'Limited revisions']
            },
            {
              name: 'Starter',
              price: '$5 / month',
              bullets: ['Up to 10 resumes', 'Keyword ATS', 'Assistant support']
            },
            {
              name: 'Pro',
              price: '$12 / month',
              bullets: ['Up to 30 resumes', 'Semantic ATS', 'Heatmap insights (coming)', 'Assistant actions (logged in)']
            }
          ].map((p, i) => (
            <div key={i} style={{ borderRadius: 18, border: '1px solid var(--border)', background: 'var(--panel)', padding: 14 }}>
              <div style={{ fontWeight: 1000, fontSize: 16 }}>{p.name}</div>
              <div style={{ marginTop: 8, fontWeight: 1000, fontSize: 26, letterSpacing: '-0.03em' }}>{p.price}</div>
              <div style={{ marginTop: 10, display: 'grid', gap: 8, color: 'var(--muted)', lineHeight: 1.6 }}>
                {p.bullets.map((b, j) => (
                  <div key={j} style={{ borderRadius: 12, border: '1px solid var(--border)', background: 'var(--bg)', padding: '10px 10px', fontWeight: 800 }}>
                    {b}
                  </div>
                ))}
              </div>
              <div style={{ marginTop: 12, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                <Link
                  href="/login"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 12px',
                    borderRadius: 12,
                    border: '1px solid #0b0b0f',
                    background: '#0b0b0f',
                    color: '#ffffff',
                    textDecoration: 'none',
                    fontWeight: 1000
                  }}
                >
                  Get started
                </Link>
                <Link
                  href="/dashboard/billing"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '10px 12px',
                    borderRadius: 12,
                    border: '1px solid var(--border)',
                    background: 'var(--panel)',
                    color: 'var(--text)',
                    textDecoration: 'none',
                    fontWeight: 1000
                  }}
                >
                  Billing
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div style={{ marginTop: 14, borderRadius: 18, border: '1px solid var(--border)', background: 'var(--panel)', padding: 14 }}>
          <div style={{ fontWeight: 1000, fontSize: 16 }}>One-time packs</div>
          <div style={{ marginTop: 10, display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12 }}>
            {[
              { name: '3 credits', price: '$3' },
              { name: '10 credits', price: '$8' },
              { name: '30 credits', price: '$15' }
            ].map((x, i) => (
              <div key={i} style={{ borderRadius: 16, border: '1px solid var(--border)', background: 'var(--bg)', padding: 12 }}>
                <div style={{ fontWeight: 1000 }}>{x.name}</div>
                <div style={{ marginTop: 6, fontWeight: 1000, fontSize: 20 }}>{x.price}</div>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 10, color: 'var(--muted)', lineHeight: 1.6 }}>
            Payments and upgrades are managed inside your dashboard billing page.
          </div>
        </div>

        <style jsx>{`
          @media (max-width: 980px) {
            div[style*='grid-template-columns: repeat(3, 1fr)'] {
              grid-template-columns: 1fr !important;
            }
            h1 {
              font-size: 38px !important;
            }
          }
        `}</style>
      </section>
    </MarketingShell>
  )
}
